module.exports = __webpack_public_path__ + "static/gallery37-f9040b41dc39271945becd573e9c7255.png";